import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Icon } from 'components';
import { Tooltip } from '@beef/ui-kit';
import { OptionAccumulator } from './OptionAccumulator';
import { OptionTitle } from './OptionTitle';

import { accumulatorShape } from '../../../propTypes';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const PackageOption = ({
  operationType, icon, title, value, description, onClick,
  accumulatorData, isOffer,
}) => {
  const Tag = onClick ? 'button' : 'div';
  const accumulatorType = accumulatorData && accumulatorData[operationType];
  const notRestAccumulator = !!isOffer && (accumulatorData && accumulatorType?.rest === 0);
  const isClickable = onClick && !isOffer;
  const handleClick = isClickable ? () => onClick(operationType) : () => {};

  return (
    <Tag
      className={cx('option', { 'option__background': notRestAccumulator }, { 'option__clickable': isClickable })}
      onClick={handleClick}
    >
      <div className={cx('option__container')}>
        <OptionTitle icon={icon} title={title} />
        <OptionAccumulator
          accumulatorData={accumulatorData}
          accumulatorType={accumulatorType}
          operationType={operationType}
          description={description}
          value={value}
        />
        {isClickable && (
          <Icon className={cx('right-aside__arrow')} name="arrow" />
        )}
        {notRestAccumulator && (
          <Tooltip position="top" labelPosition="right" message={`${title} ${value}`}>
            <Icon className={cx('right-aside__icon')} name="info" />
          </Tooltip>
        )}
      </div>
    </Tag>
  );
};

PackageOption.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  description: PropTypes.string,
  operationType: PropTypes.string,
  isOffer: PropTypes.bool,
  accumulatorData: PropTypes.arrayOf(accumulatorShape),
  icon: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.func,
  ]),
  onClick: PropTypes.func,
};

export default PackageOption;
